import React, { useEffect } from "react";
import ScrollMagic from "scrollmagic";
import Value from "../Components/Value/Value";
import Bannerpage from "../Components/Bannerpage/Bannerpage";
import "../App.css";
import Countercard from "../Components/Countercard/Countercard";
import ExploreWork from "../Components/ExploreWork/ExploreWork";
import Buildteach from "../Components/Buildteach/Buildteach";
import Onestep from "../Components/Onestep/Onestep";
import Testimonial from "../Components/Testomonial/Testomonial";
import About from "../Components/About/About";
import Contactpage from "./Contactpage/Contactpage";
import CookieConsent from "../Components/CookieConsent ";
import { Helmet } from "react-helmet-async";

const HomePage = () => {
  useEffect(() => {
    const controller = new ScrollMagic.Controller();

    const triggerElement = document.getElementById("triggerPinned");

    if (window.innerWidth > 768 && triggerElement.length !== 0) {
      new ScrollMagic.Scene({
        triggerElement: triggerElement,
        triggerHook: -1.3,
      })
        .setPin(triggerElement)
        .addTo(controller);
    }

    return () => controller.destroy();
  }, []);

  return (
    <>
      <Helmet>
        <title>Owision – Expert IT Solutions & Digital Transformation</title>
        <meta
          name="description"
          content="Owision delivers cutting-edge IT services, cloud solutions, and digital transformation support to global clients across industries. Partner with innovation leaders."
        />
      </Helmet>
      <div style={{ overflowX: "hidden" }}>
        <div style={{ overflowX: "hidden" }}>
          <section id="bannerPage" className="sectionBackgroundImage">
            <Bannerpage />
          </section>

          <section>
            <Countercard />
          </section>

          <section>
            <ExploreWork />
          </section>

          <section>
            <Value />
          </section>

          <section
            className="shop-section"
            id="triggerPinned"
            style={{
              minHeight: "100vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "1",
            }}
          >
            <Onestep />
          </section>

          <section
            style={{
              background: "#fff",
              borderTopRightRadius: "60px",
              borderTopLeftRadius: "60px",
              marginTop: "3rem",
              padding: "1rem 0 ",
              zIndex: "11111",
              position: "relative",
            }}
            className="white-section"
          >
            <Buildteach />
            <section className="bg-color-change">
              <section
                style={{
                  position: "relative",
                  zIndex: "1111",
                }}
                className=" mt-0 md:mt-[3rem]"
                id="About"
              >
                <About />
                <hr
                  style={{
                    width: "90%",
                    margin: "auto",
                    border: "1px solid #fff",
                  }}
                  className="!my-5 md:mt-[4rem]"
                />
              </section>
              <section style={{ position: "relative", zIndex: "111" }}>
                <Testimonial />
              </section>
            </section>

            <section className="contact-content-data" id="contactId">
              <Contactpage />
            </section>
          </section>
        </div>
        <CookieConsent />
      </div>
    </>
  );
};

export default HomePage;
